module.exports = __webpack_public_path__ + "static/media/analytics.691dca6f.svg";